module.exports = __webpack_public_path__ + "static/media/purchaseNewKTM.906daa14.svg";